import Navbar from "../components/Navbar";
import Footer from "../components/Footer";



function Defi({ ConnectWalletFunc, state, setState, disconnectWallet }) {
    // const [myState, setMyState] = useState("1");


    return (
        <>
            <section className="defi_section">
                <div className="glass">
                    <Navbar ConnectWalletFunc={ConnectWalletFunc} isConnect={state} setIsConnect={setState} disconnectWallet={disconnectWallet} />
                </div>


                {
                    process.env.REACT_APP_ENVIRONMENT === "production" ?
                        <>
                            <div className="container">
                                {
                                    state.length === 0 ?
                                        <div className="row justify-content-center align-items-center">
                                            <div className="col-lg-6 col-md-6 col-12 cat_col mb-5">
                                                <div className="card mx-1">
                                                    <div className="content">
                                                        <button className="btn wallet_btn" onClick={() => ConnectWalletFunc()}>Connect Wallet</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="row justify-content-center align-items-center ">
                                            <div className="col-lg-4 col-md-6 col-12 cat_col mb-5">
                                                <div className="card mx-1">
                                                    <div className="content">
                                                        <div className='justify-content-center text-center'>
                                                            <h2>FISH-ETH-LP</h2>
                                                        </div>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className="name">
                                                                <h3>APY</h3>
                                                            </div>
                                                            <div className="value">
                                                                <h4>41.33%</h4>
                                                            </div>
                                                        </div>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className="name">
                                                                <h3>Total Staked</h3>
                                                            </div>
                                                            <div className="value">
                                                                <h4>9,258.96 FISH-ETH</h4>
                                                                <h4>(33,012.7 USDT)</h4>
                                                            </div>
                                                        </div>
                                                        <button className="btn">Stake</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6 col-12 cat_col mb-5">
                                                <div className="card mx-1">
                                                    <div className="content">
                                                        <div className='justify-content-center text-center'>
                                                            <h2>FISH</h2>
                                                        </div>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className="name">
                                                                <h3>APY</h3>
                                                            </div>
                                                            <div className="value">
                                                                <h4>43.05%</h4>
                                                            </div>
                                                        </div>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className="name">
                                                                <h3>Total Staked</h3>
                                                            </div>
                                                            <div className="value">
                                                                <h4>4,472,416.83 FISH</h4>
                                                                <h4>(6,355.15 USDT)</h4>
                                                            </div>
                                                        </div>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className="name">
                                                                <h3>My Staked</h3>
                                                            </div>
                                                            <div className="value">
                                                                <h4>0 FISH</h4>
                                                            </div>
                                                        </div>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className="name">
                                                                <h3>Rewards</h3>
                                                            </div>
                                                            <div className="value">
                                                                <h4>0 FISH</h4>
                                                            </div>
                                                        </div>
                                                        <button className="btn">Stake</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6 col-12 cat_col mb-5">
                                                <div className="card mx-1">
                                                    <div className="content">
                                                        <div className='justify-content-center text-center'>
                                                            <h2>ARB</h2>
                                                        </div>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className="name">
                                                                <h3>APY</h3>
                                                            </div>
                                                            <div className="value">
                                                                <h4>5.77%</h4>
                                                            </div>
                                                        </div>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className="name">
                                                                <h3>Total Staked</h3>
                                                            </div>
                                                            <div className="value">
                                                                <h4>1,745.56 ARB</h4>
                                                                <h4>(2,370.65 USDT)</h4>
                                                            </div>
                                                        </div>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className="name">
                                                                <h3>My Staked</h3>
                                                            </div>
                                                            <div className="value">
                                                                <h4>0 ARB</h4>
                                                            </div>
                                                        </div>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className="name">
                                                                <h3>Rewards</h3>
                                                            </div>
                                                            <div className="value">
                                                                <h4>0 ARB</h4>
                                                            </div>
                                                        </div>
                                                        <button className="btn">Stake</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                }
                            </div>
                        </>
                        :
                        <>
                            <div className="row justify-content-center align-items-center" style={{ height: "70vh" }}>
                                <div className="col-lg-6 col-md-6 col-12 cat_col mb-5">
                                    <div className="card connect_card mx-1">
                                        <div className="content" style={{ minHeight: "250px", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <h1 style={{ color: "#444c7f", fontSize: "40px" }}>Coming Soon!!!</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                }

            </section>
            <Footer />
        </>
    )

}

export default Defi